import React, {Component} from 'react';
import ReactBodymovin from 'react-bodymovin';
import { parseDecodedCurioso, decodeCurioso } from '../lib/utilityFunctions';
import animation from '../content/curiosoAnimation.json';
import '../CuriosoLayers.css';

class CustomizedCurioso extends Component {
  constructor(props) {
    super(props);
    this.bmData = {
      loop: true,
      autoplay: false,
      prerender: false,
      animationData: animation,
    };
    this.augmentationStyles = [];
  }

  componentDidMount() {
    this.curiosoTypes = document.getElementsByClassName("type");
    const decodedCurioso = decodeCurioso(this.props.encodedCurioso);
    const {curiosoName, augmentations, curiosoNumber, descriptionStrings} = parseDecodedCurioso(decodedCurioso);

    this.curiosoName = curiosoName; // TODO: Curioso name isn't showing up. Possibly it needs to be in state?
    this.changeCuriosoType(curiosoNumber);
    this.applyAugmentations(augmentations);

    console.log(descriptionStrings);
  }

  componentWillUnmount() {
    this.removeAugmentations();
  }

  changeCuriosoType = (type) => {
    for(let i = 0; i < this.curiosoTypes.length; i++) {
      this.curiosoTypes[i].style.display = i === type ? "block" : "none";
    }
  }

  applyAugmentations = (augmentations) => {
    for(let i = 0; i < augmentations.length; i++) {
      var sheet = document.createElement('style')
      sheet.innerHTML = `.aug.${augmentations[i]} { display: block; }`;
      document.body.appendChild(sheet);
      this.augmentationStyles.push(sheet);
    }
  }

  removeAugmentations = () => {
    for(let i = 0; i < this.augmentationStyles.length; i++) {
      document.body.removeChild(this.augmentationStyles[i]);
    }
  }

  onRefRender = (ref) => {
    // 60 - 120 are the idle frames.

var walkFrames = [0, 60],
    idleFrames = [60, 120],
    jumpFrames = [120, 170],
    happyFrames = [170, 220],
    sadFrames = [220, 275],
    curiosFrames = [275, 330];

var framesArray = [jumpFrames,happyFrames,sadFrames,curiosFrames];

var curiosoState = Math.floor((Math.random() * framesArray.length) + 1);
    if (ref && ref.animation) {
      ref.animation.playSegments([framesArray[curiosoState], idleFrames], true);
    }
  }

  render() {
    return (
      <div style={{width: 400, height: 400}}>
        <ReactBodymovin options={this.bmData} ref={this.onRefRender} />
      </div>
    )
  }
}

export default CustomizedCurioso;